export function isTargetParent(target, parentRef) {
  var _parentRef$current;

  // Must validate that "target" is a DOM element because it could be anything like "window".
  return target instanceof Element && ((_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : _parentRef$current.contains(target));
}